module.exports = __webpack_public_path__ + "img/8.92085362.jpg";